module.exports = __webpack_public_path__ + "img/icon-speed-3.9dad82f0.svg";